// src/components/SignOut.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function SignOutConfirm() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await logout();              // calls PHP /logout.php + clears sessionStorage
      } catch (e) {
        console.warn("Logout failed", e);
      } finally {
        if (!cancelled) {
          navigate("/login", { replace: true }); // send user to login screen
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [logout, navigate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      Signing you out…
    </div>
  );
}
